import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d69016e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["fill"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "m2.1167 0-1.0583 1.3229-1.0583-1.3229z",
  "stroke-width": "0"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    width: "8",
    height: "5",
    fill: _ctx.color,
    class: _normalizeClass({ collapsed: _ctx.collapsed }),
    version: "1.1",
    viewBox: "0 0 2.1167 1.3229",
    xmlns: "http://www.w3.org/2000/svg"
  }, _hoisted_3, 10, _hoisted_1))
}